/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { Progress } from '@scuf/common';
import './CommonProgressBar.scss';
import { IAggregationData } from '../ProgressBar/IProgressBarWidget';
import {
  getBaselineArrowUpdated,
  getGreyLineWidth,
  getPercentByColor,
  getSavings,
  progressBarCalculation,
  ternaryOpration
} from './CommonProgressBarUtils';
import { getNullToZero } from '../Utils/EnergyUsagesViewDetailsUtils';
import {
  PERCENTAGE_HUNDRED,
  PROGRESS_GREY_PERCENTAGE
} from '../Utils/Constants';
const commonProgressBar = (props: IAggregationData) => {
  let {
    actual,
    previousPeriod,
    savings,
    progessBarRelativeWidth,
    category
  } = props;
  savings =
    actual === 0 || previousPeriod === 0 || savings === null
      ? getSavings(null, null, null)
      : getSavings(savings, previousPeriod, actual);
  let ProgressGreyPercentage = getGreyLineWidth(
    actual === 0 || previousPeriod === 0 ? 0 : getNullToZero(actual),
    actual === 0 || previousPeriod === 0 ? 0 : getNullToZero(previousPeriod),
    actual === 0 || previousPeriod === 0 ? null : progessBarRelativeWidth
  );
  ProgressGreyPercentage =
    ProgressGreyPercentage <= PROGRESS_GREY_PERCENTAGE
      ? PROGRESS_GREY_PERCENTAGE
      : ProgressGreyPercentage;
  let { percentBlue, percentRed, emptyActualAndPreviousdata } =
    actual === 0 || previousPeriod === 0 || savings === null
      ? progressBarCalculation(null, null, null)
      : progressBarCalculation(actual, previousPeriod, savings);
  const minvalue = 0;
  const getsavingsPercentageClassName = ternaryOpration(
    getNullToZero(savings) < minvalue,
    'negative-savings',
    'positive-savings'
  );
  const getSavingProgressClassName =
    '' +
    ternaryOpration(
      emptyActualAndPreviousdata,
      'actual-previous-empty-data',
      getsavingsPercentageClassName
    );

  let { updatedBlue, updatedRed, greyPecentage } = getPercentByColor(
    percentBlue as number,
    percentRed,
    ProgressGreyPercentage,
    actual === 0 || previousPeriod === 0 || savings === null ? null : actual,
    actual === 0 || previousPeriod === 0 || savings === null
      ? null
      : previousPeriod
  );
  const baselineArrow = getBaselineArrowUpdated(
    actual === 0 || previousPeriod === 0 || savings === null
      ? null
      : previousPeriod,
    actual === 0 || previousPeriod === 0 || savings === null ? null : actual,
    updatedRed,
    greyPecentage
  );

  return (
    <div className="emaas-common-progress-container">
      <div className="progress-bar">
        <div
          className="actual-progress"
          style={{
            width: `${updatedBlue}%`,
            paddingRight: '0.12rem'
          }}
        >
          <Progress
            size="xxsmall"
            className="actual-progress-bar"
            percent={PERCENTAGE_HUNDRED}
          />
        </div>
        <div
          className="saving-progress"
          style={{
            width: `${Math.abs(updatedRed)}%`,
            paddingRight: '0.12rem'
          }}
        >
          <Progress
            className={getSavingProgressClassName}
            size="xxsmall"
            percent={PERCENTAGE_HUNDRED}
          />
        </div>
        <div
          className="grey-progress"
          style={{
            width: `${Math.abs(greyPecentage)}%`
          }}
        >
          <Progress
            className={'grey-progress'}
            size="xxsmall"
            percent={PERCENTAGE_HUNDRED}
          />
        </div>
        {previousPeriod !== null &&
          actual !== 0 &&
          previousPeriod !== 0 &&
          savings !== null && (
            <div
              className="baseline-line"
              style={{ left: `${baselineArrow}%` }}
            ></div>
          )}
      </div>
    </div>
  );
};

export default commonProgressBar;
